import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  VStack,
  HStack,
  FormLabel,
  Badge,
  Image
} from '@chakra-ui/react';
import { Toggle } from '../../components/Toggle';
import { usePricingPlan } from './usePricingPlan';
  
  
export const PricingPlan = ({isPro=false}) => {

  const {
    plans,
    isYearly,
    setIsYearly,
    upgradeToPro,
    loading,
    publisher
  } = usePricingPlan();
  

  return (
    <Box py={12} px={4}>
      <VStack spacing={4} textAlign="center">
        <Heading fontSize="3xl">Simple plans for everyone</Heading>

        <HStack spacing={4}>
          <Text>Pay Monthly</Text>
          <FormLabel htmlFor="billing-switch" mb="0">
              <Toggle onChange={() => setIsYearly(!isYearly)} isChecked={isYearly}/>
          </FormLabel>
          <Text>Pay Yearly</Text>
        </HStack>
      </VStack>

      <Flex
        mt={10}
        direction={{ base: 'column', md: 'column', lg: 'row' }}
        justify="center"
        align="stretch"
        align-items={{base: 'flex-start', md: 'flex-start', lg: 'center'}}
        gap={6}
      >
        {plans.map((plan, index) => {
          const price = isYearly ? plan.yearlyPrice : plan.monthlyPrice;
          const planFrequency = isYearly ? "year" : "month"
          const priceDisplay =
            price === 0
              ? '$0'
              : isYearly
              ? `$${price.toFixed(2)} /yr`
              : `$${price.toFixed(2)} /mo`;
          const currentPlan = isPro ? "Pro" : "Free"
          return (
            <Box
              key={index}
              borderWidth={2}
              borderRadius="lg"
              borderColor={isPro ? currentPlan === plan.name && publisher?.subscriptionInfo?.frequency === planFrequency ? 'blue.500' : 'gray.200' : currentPlan === plan.name ? 'blue.500' : 'gray.200'}
              bg="white"
              p={6}
              w={{ base: '100%', md: '300px' }}
            >
              <VStack spacing={4}>
                <Text fontWeight="bold" fontSize="lg">
                  {plan.name}
                </Text> 
                {
                  isPro ? 
                    currentPlan === plan.name && publisher?.subscriptionInfo?.frequency === planFrequency ? <Badge colorScheme="blue">Current Plan</Badge> : null :
                    currentPlan === plan.name ? <Badge colorScheme="blue">Current Plan</Badge> : null
                }
                <Text fontSize="2xl" fontWeight="semibold">
                  {priceDisplay}
                </Text>
              </VStack>
              <VStack align="start" spacing={2} mt={8}>
                  {plan.features.map((feat, i) => (
                      <Flex key={i} alignItems="center" mt={2}>
                          <Image src="/images/tick.svg" alt="checkmark" width="20px" mr={2}/> 
                          <Text fontSize="14px" letterSpacing= "0.35px" color="gray.600">{feat.label}</Text>
                      </Flex>
                  ))}
              </VStack>
              {
                currentPlan === plan.name && publisher?.subscriptionInfo?.frequency === planFrequency ? null :
                publisher?.subscriptionInfo?.frequency === "year" ?
                <Button
                    isLoading={loading}
                    colorScheme={plan.name === 'Pro' ? 'blue' : 'gray'}
                    variant={'outline'}
                    w="full"
                    visibility={plan.buttonText ? "visible" : "hidden"}
                    mt={10}
                    onClick={upgradeToPro}
                >
                    Downgrade
                </Button> :
                <Button
                  isLoading={loading}
                  colorScheme={plan.name === 'Pro' ? 'blue' : 'gray'}
                  variant={plan.name === 'Pro' ? 'solid' : 'outline'}
                  w="full"
                  visibility={plan.buttonText ? "visible" : "hidden"}
                  mt={10}
                  onClick={upgradeToPro}
                >
                    Upgrade
                </Button>
              }
            </Box>
          );
        })}
      </Flex>
    </Box>
  );
};
